import { defineMessages } from "react-intl";

const messages = defineMessages({
  shopProducts: {
    defaultMessage: `{productsCount, plural,
       =0 {Shop 0 products}
       one {Shop 1 product}
       other {Shop {productsCount} products}}`,
  },
  totalWorks: {
    defaultMessage: `{worksCount, plural,
       =0 {0 designs}
       one {1 design}
       other {{worksCount} designs}}`,
  },
  viewComments: {
    defaultMessage: "Comments",
  },
  workShareTitle: {
    defaultMessage: "{title} by {name}",
  },
});

export default messages;
